<template>
  <div class="viq-report-types">
    <h2 class="viq-report-types__title">Choose a Report Type</h2>
    <p class="viq-report-types__subtitle">
      Select a report format to generate AI-powered regulatory intelligence reports.
    </p>

    <div class="viq-report-types__grid">
      <div
        v-for="rt in reportTypes"
        :key="rt.id"
        class="viq-report-types__card"
        @click="selectType(rt.id)"
      >
        <div class="viq-report-types__card-icon" :style="{ background: rt.bgColor }">
          <span>{{ rt.emoji }}</span>
        </div>
        <h3 class="viq-report-types__card-title">{{ rt.title }}</h3>
        <p class="viq-report-types__card-desc">{{ rt.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqReportTypeSelector",
  data() {
    return {
      reportTypes: [
        {
          id: "board",
          title: "Board Report",
          description: "Comprehensive board-ready regulatory briefing with executive summary, key findings, and recommendations.",
          emoji: "\uD83D\uDCCB",
          bgColor: "rgba(37, 99, 235, 0.1)",
        },
        {
          id: "timeline",
          title: "Timeline",
          description: "Chronological overview of regulatory events, milestones, and upcoming deadlines for a topic or jurisdiction.",
          emoji: "\u23F1",
          bgColor: "rgba(16, 185, 129, 0.1)",
        },
        {
          id: "gap-analysis",
          title: "Gap Analysis",
          description: "Identify compliance gaps by answering guided questions. Get severity ratings and remediation recommendations.",
          emoji: "\u2705",
          bgColor: "rgba(245, 158, 11, 0.1)",
        },
        {
          id: "market-entry",
          title: "Market Entry",
          description: "Regulatory landscape assessment for entering a new jurisdiction at Discovery, Operational, or Comprehensive depth.",
          emoji: "\uD83C\uDF0D",
          bgColor: "rgba(139, 92, 246, 0.1)",
        },
        {
          id: "compare-markets",
          title: "Compare Markets",
          description: "Side-by-side comparison of regulatory frameworks across multiple jurisdictions for strategic planning.",
          emoji: "\uD83D\uDCCA",
          bgColor: "rgba(236, 72, 153, 0.1)",
        },
        {
          id: "expansion",
          title: "Expansion Opportunity",
          description: "Evaluate expansion opportunities with market readiness heatmaps, regulatory paths, and risk rankings.",
          emoji: "\uD83D\uDE80",
          bgColor: "rgba(14, 165, 233, 0.1)",
        },
      ],
    };
  },
  methods: {
    selectType(type) {
      this.$store.dispatch("Viq/selectReportType", type);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-report-types {
  max-width: 780px;
  margin: 0 auto;
  padding: $viq-space-xl 0;

  &__title {
    font-size: $viq-font-xl;
    font-weight: 800;
    color: $viq-text-primary;
    margin: 0 0 $viq-space-sm;
    text-align: center;
  }

  &__subtitle {
    font-size: $viq-font-md;
    color: $viq-text-secondary;
    text-align: center;
    margin: 0 0 $viq-space-xl;
    line-height: 1.5;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: $viq-space-md;
  }

  &__card {
    padding: $viq-space-lg;
    background: $viq-bg-primary;
    border: 2px solid $viq-border;
    border-radius: $viq-radius-lg;
    cursor: pointer;
    transition: border-color $viq-transition-fast, box-shadow $viq-transition-fast, transform $viq-transition-fast;

    &:hover {
      border-color: $viq-accent;
      box-shadow: $viq-shadow-md;
      transform: translateY(-2px);
    }

    &-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      border-radius: $viq-radius-md;
      margin-bottom: $viq-space-md;
      color: $viq-text-primary;
    }

    &-title {
      font-size: $viq-font-md;
      font-weight: 700;
      color: $viq-text-primary;
      margin: 0 0 $viq-space-sm;
    }

    &-desc {
      font-size: $viq-font-sm;
      color: $viq-text-secondary;
      margin: 0;
      line-height: 1.5;
    }
  }
}
</style>
